var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrorProjectorConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 116,
    height: 217,
    viewBox: "0 0 116 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: 2.5,
    y: 95.5,
    width: 111,
    height: 119,
    rx: 7.5,
    stroke: "#D6AF66",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 83,
    cy: 155,
    r: 10.5,
    transform: "rotate(-180 83 155)",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 32,
    cy: 155,
    r: 10.5,
    transform: "rotate(-180 32 155)",
    stroke: "#D6AF66",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 55.5,
    cy: 36.5,
    r: 36.5,
    fill: "#D6AF66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.9139 30.6163V42.1542L78 50V23L68.9139 30.6163ZM39.0204 23H61.9804C65.3242 23 68.8889 25.7068 68.8889 29.3068V47.7478C68.895 48.3366 68.6648 48.9039 68.2486 49.3255C67.8324 49.7472 67.2641 49.9889 66.6681 49.9978H43.0407C39.2436 49.9978 37 46.6227 37 43.2477L37.0228 25.2478C36.9796 24.9635 36.9996 24.6733 37.0815 24.3974C37.1633 24.1216 37.3049 23.8666 37.4966 23.6503C37.6855 23.4363 37.9208 23.2671 38.185 23.1553C38.4492 23.0436 38.7355 22.992 39.0227 23.0045L39.0204 23Z",
    stroke: "#960018",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorProjectorConsole);
export default __webpack_public_path__ + "static/media/mirror-projector-console.3ad8b707ca81ce33531945d49984404e.svg";
export { ForwardRef as ReactComponent };